import { TYPE_MOVITEL_ERROR_CODE, TYPE_MOVITEL_MAGICWHEEL, TYPE_MOVITEL_REVENUE, TYPE_MOVITEL_VM  } from "./type";

export const getDataRevenueMovitel = (url) => {
  return {
    type: TYPE_MOVITEL_REVENUE,
    meta: {
      url,
      method: "GET",
    },
  };
};

export const getDataErrorCodeMovitel = (url) => {
  return {
    type: TYPE_MOVITEL_ERROR_CODE,
    meta: {
      url,
      method: "GET",
    },
  };
};

export const getDataVmMovitel = (url) => {
  return {
    type: TYPE_MOVITEL_VM,
    meta: {
      url,
      method: "GET",
    },
  };
};

export const getDataMagicWheel = (url) => {
  return {
    type: TYPE_MOVITEL_MAGICWHEEL,
    meta: {
      url,
      method: "GET",
    },
  };
};
